import { Component, Input, OnInit, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { AppService } from '../../app.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../../support/success-snackbar/success-snackbar.component';
import { messageService } from 'src/app/message.service';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { StaticAuditTrailComponent } from '../../support/static-audit-trail/static-audit-trail.component';
import { ExcelPdfComponent } from '../../support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-dms-settings',
  templateUrl: './dms-settings.component.html',
  styleUrls: ['./dms-settings.component.scss']
})

export class DmsSettingsComponent implements OnInit, AfterViewInit {

  isProcessing = true;
  isDmsSettingsDataEmpty = false;
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  dropDownForReportTimezone: any = [];
  selectedTimeZone: any = null;
  timeZoneDropdown: any = [];
  dmsSettingsList: any = [];
  popupDataTitle: PopupData = {
    title: ''
  };

  oddTimezone: any = null;
  @Input() dmsSettingsObj: any = {};

  ngOnInit() {
    this.isProcessing = true;
    this.dropDownForReportTimezone = JSON.parse(sessionStorage.getItem('dropDownForReportTimezone') ?? '{}');
    this.selectBoxForTimeZone();
    this.appService.getDmsSettingVw().subscribe({
      next: (data: any) => {
        if (data == null) {
          this.dmsSettingsList = data;
          this.dmsSettingsObj = {};
          this.dmsSettingsObj['allowToInputVersionManually1'] = false;
          this.dmsSettingsObj['allowToInputDocumentNoManually1'] = false;
          this.dmsSettingsObj['onlineEditor'] = false;
          this.dmsSettingsObj['trainingCompletionPercentageCheckForDocumentPublishReqd'] = false;
          this.isDmsSettingsDataEmpty = true;
          this.isProcessing = false;
        } else {
          this.dmsSettingsList = data;

          if (this.dmsSettingsList.reportsTimezone) {
            const matchingTimeZone = this.dropDownForReportTimezone?.find((item: any) => item.codelistCode == this.dmsSettingsList.reportsTimezone);
            if (!matchingTimeZone) {
              this.oddTimezone = this.dmsSettingsList.reportsTimezone;
              this.timeZoneDropdown.push({
                valueExp: this.dmsSettingsList.reportsTimezone,
                displayExp: this.dmsSettingsList.reportsTimezone
              })
            }
            this.selectedTimeZone = this.dmsSettingsList.reportsTimezone;
          }
          this.dmsSettingsObj = this.dmsSettingsList;
          this.dmsSettingsObj['allowToInputVersionManually1'] = this.dmsSettingsObj['allowToInputVersionManually'] == "Y";
          this.dmsSettingsObj['allowToInputDocumentNoManually1'] = this.dmsSettingsObj['allowToInputDocumentNoManually'] == "Y";
          this.dmsSettingsObj['onlineEditor'] = this.dmsSettingsObj['onlineEditor'] == "Y";
          this.dmsSettingsObj['trainingCompletionPercentageCheckForDocumentPublishReqd'] = this.dmsSettingsObj['trainingCompletionPercentageCheckForDocumentPublishReqd'] == "Y";
          this.dmsSettingsObj.selectedAllowedFileExtns = this.dmsSettingsObj.allowedFileExtns.split(",");
          this.isDmsSettingsDataEmpty = false;
          this.isProcessing = false;
        }
      }, error: (error) => {
        this.isProcessing = false;
      }
    })

    this.appService.getOneQmsOrganization().subscribe((data: any) => {
      this.organizationDetails = data;
      this.allowedFileExtnListMethod();
    });
  }
  organizationDetails: any;
  allowedFileExtnsSearchText: any = "";
  allSelected = false;
  allCoreBusinessSelected = false;
  @ViewChild('reasonForChange') reasonForChange: MatSelect;
  toggleAllSelection(value: any) {
    if (value == 'reasonForChange') {
      if (this.allSelected) {
        this.reasonForChange.options.forEach((item: MatOption) => item.select());
      } else {
        this.reasonForChange.options.forEach((item: MatOption) => item.deselect());
      }
    }

  }
  allowedFileExtnList: any;
  allowedFileExtnListMethod() {
    let list = this.organizationDetails.allowedFileExtns.split(",");
    this.allowedFileExtnList = list.map((e: any) => ({
      valueExp: e,
      displayExp: e
    }));
  };
  constructor(public appService: AppService, public dialog: MatDialog, private readonly snackBar: MatSnackBar, public message: messageService,) { }

  refreshForm() {
    this.ngOnInit();
  }

  footerValidationIcon: any;
  waterValidationIcon: any;
  documentNameValidationIcon: any;
  ngAfterViewInit() {
    this.footerValidationIcon = document.getElementById('footerMsg-val-icon') as HTMLInputElement;
    this.waterValidationIcon = document.getElementById('waterMsg-val-icon') as HTMLInputElement;
    this.documentNameValidationIcon = document.getElementById('documentNameFormat-val-icon') as HTMLInputElement;
    this.footerValidationIcon.innerHTML = '<i class="fas fa-exclamation-circle"></i>';
    this.footerValidationIcon.style.color = "green";
    this.waterValidationIcon.innerHTML = '<i class="fas fa-exclamation-circle"></i>';
    this.waterValidationIcon.style.color = "green";
    this.documentNameValidationIcon.innerHTML = '<i class="fas fa-exclamation-circle"></i>';
    this.documentNameValidationIcon.style.color = "green";
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };

  config: EditorConfig = {
    placeholder: '',
    buttons: ST_BUTTONS,
  };

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  selectBoxForTimeZone() {
    this.timeZoneDropdown = [];
    this.timeZoneDropdown = this.dropDownForReportTimezone?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }))
  }

  reportsTimezonesearchTxt: any;

  onReportsTimezoneSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedTimeZone = item.valueExp;
      } else {
        this.selectedTimeZone = undefined;
      }
    }
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  saveDmsSettings(fieldData: any) {
    if (fieldData['trainingCompletionPercentageCheckForDocumentPublishReqd'] && !fieldData['trainingCompletionPercentageForDocumentPublish']) {
      setTimeout(() => { this.showSnackBar("Please enter the Minimum Training Completion Percentage!", "E") });
      return;
    }
    if (this.isDmsSettingsDataEmpty) {
      this.isProcessing = true;

      fieldData['allowToInputVersionManually'] = fieldData['allowToInputVersionManually1'] ? "Y" : "N";
      fieldData['allowToInputDocumentNoManually'] = fieldData['allowToInputDocumentNoManually1'] ? "Y" : "N";
      fieldData['onlineEditor'] = fieldData['onlineEditor'] ? "Y" : "N";
      fieldData['trainingCompletionPercentageCheckForDocumentPublishReqd'] = fieldData['trainingCompletionPercentageCheckForDocumentPublishReqd'] ? "Y" : "N";
      fieldData['reportsTimezone'] = this.selectedTimeZone ?? null;
      fieldData['allowedFileExtns'] = fieldData['selectedAllowedFileExtns']?.join(",");
      this.appService.createDmsSettings(fieldData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == "S") {
            this.ngOnInit();
          }
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      })
    } else {
      delete fieldData['createdOn'];
      delete fieldData['updatedOn'];
      this.isProcessing = true;

      fieldData['allowToInputVersionManually'] = fieldData['allowToInputVersionManually1'] ? "Y" : "N";
      fieldData['allowToInputDocumentNoManually'] = fieldData['allowToInputDocumentNoManually1'] ? "Y" : "N";
      fieldData['onlineEditor'] = fieldData['onlineEditor'] ? "Y" : "N";
      fieldData['trainingCompletionPercentageCheckForDocumentPublishReqd'] = fieldData['trainingCompletionPercentageCheckForDocumentPublishReqd'] ? "Y" : "N";
      fieldData['reportsTimezone'] = this.selectedTimeZone ?? null;
      fieldData['allowedFileExtns'] = fieldData['selectedAllowedFileExtns']?.join(",");
      this.appService.updateDmsSettings(fieldData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == "S") {
            this.ngOnInit();
          }
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = false;
          this.isProcessing = false;
          throw error;
        }
      })
    }
  }

  @ViewChild('deleteDmsSettingsPopup', { static: true }) deleteDmsSettingsPopup: TemplateRef<any>;
  @ViewChild('notePopup', { static: true }) notePopup: TemplateRef<any>;


  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleNotePopup: MatDialogRef<TemplateRef<any>>;

  deleteDmsSettingsPopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '60px' },
  };

  notePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '60px' },
  };

  deleteReasonFieldValue: any
  deleteReasonRequiredMsg: any

  deleteReasonValidation() {
    this.deleteReasonRequiredMsg = document.getElementById('deleteReason-required-msg') as HTMLInputElement;

    if (this.deleteReasonFieldValue.value == "" || this.deleteReasonFieldValue.value == null || this.deleteReasonFieldValue.value == undefined) {
      this.deleteReasonFieldValue.style.border = '1px solid red';
      this.deleteReasonRequiredMsg.style.display = 'block';
    } else {
      this.deleteReasonFieldValue.style.border = 'none';
      this.deleteReasonRequiredMsg.style.display = 'none';
    }
  }

  deleteDmsSettings(fieldData: any) {
    this.deleteReasonFieldValue = document.getElementById('deleteReason') as HTMLInputElement;
    if (this.deleteReasonFieldValue.value == "" || this.deleteReasonFieldValue.value == null || this.deleteReasonFieldValue.value == undefined) {
      this.deleteReasonValidation();
    } else {
      delete fieldData['createdOn'];
      delete fieldData['updatedOn'];
      this.isProcessing = true;

      this.appService.deleteDmsSettings(fieldData).subscribe((Response: any) => {
        this.displayMessage = Response.result;
        this.displayResultType = Response.resultType;
        if (this.displayResultType == "S") {
          this.ngOnInit();
          this.visibleDeletePopup.close();
        }
      })
    }
  }

  openDeletePopup(dmsSettingsObj: any) {
    this.popupDataTitle.title = "Delete Confirmation";
    this.visibleDeletePopup = this.dialog.open(this.deleteDmsSettingsPopup, this.deleteDmsSettingsPopupConfig);
  }

  cancelDeletePopup() {
    this.visibleDeletePopup.close();
  }

  clickToGetNote() {
    this.visibleNotePopup = this.dialog.open(this.notePopup, this.notePopupConfig);
  }

  cancelNote() {
    this.visibleNotePopup.close();
  }

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail() {
    this.message.tableOrView_Name = "DMS_SETTINGS_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,DOCUMENT_NO_FORMAT,DOCUMENT_NO_REGENERATION,DOCUMENT_NO_NO_OF_DIGITS,DOCUMENT_NO_FORMAT_FOR_ASSOCIATED_DOCS,DOCUMENT_NO_REGENERATION_FOR_ASSOCIATED_DOCS,DOCUMENT_NO_NO_OF_DIGITS_FOR_ASSOCIATED_DOCS,DOCUMENT_NO_FORMAT_FOR_AMENDMENT_DOCS,DOCUMENT_NO_REGENERATION_FOR_AMENDMENT_DOCS,DOCUMENT_NO_NO_OF_DIGITS_FOR_AMENDMENT_DOCS,ALLOWED_FILE_EXTNS,PDF_CONVERTABLE_FILE_EXTNS,VIEWABLE_FILE_EXTNS,FOOTER_MESSAGE_FORMAT,WATERMARK_MESSAGE_FORMAT,DOWNLOADED_DOCUMENT_NAME_FORMAT,STATUSES_ALLOWED_AT_TRAININGS,REPORTS_TIMEZONE,ALLOW_TO_INPUT_VERSION_MANUALLY,ALLOW_TO_INPUT_DOCUMENT_NO_MANUALLY,ONLINE_EDITOR,TRAINING_COMPLETION_PERCENTAGE_CHECK_FOR_DOCUMENT_PUBLISH_REQD,TRAINING_COMPLETION_PERCENTAGE_FOR_DOCUMENT_PUBLISH,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON";
    this.message.columnList_UI = "Created Timestamp,End Timestamp,Action,Parent Document No. Format,Parent Document No. Regeneration,Document Number No. of Digits,Document No. Format for Associated Documents,Document No. Regeneration for Associated Documents,Document Number No. of Digits for Associated Documents,Document No. Format for Amendment Documents,Document No. Regeneration for Amendment Docs,Document Number No. of Digits for Amendment Documents,Allowed File Extensions,PDF Convertible File Extensions,Viewable File Extensions,Footer Message Format,Watermark Message Format,Downloaded Document Name Format,Statuses Allowed at Trainings,Reports Timezone,Allow to Input Version Manually,Allow to Input Document No Manually,Enable Edit Online,Training Completion Percentage Check for Doc Publish Reqd,Minimum Training Completion Percentage,Created On,Created By,Updated On,Updated By,Update Reason";
    this.message.whereClause_AU = "";
    this.message.columnList_Report = "Created Timestamp,End Timestamp,Action,Parent Document No. Format,Parent Document No. Regeneration,Document Number No. of Digits,Document No. Format for Associated Documents,Document No. Regeneration for Associated Documents,Document Number No. of Digits for Associated Documents,Document No. Format for Amendment Documents,Document No. Regeneration for Amendment Docs,Document Number No. of Digits for Amendment Documents,Allowed File Extensions,PDF Convertible File Extensions,Viewable File Extensions,Footer Message Format,Watermark Message Format,Downloaded Document Name Format,Statuses Allowed at Trainings,Reports Timezone,Allow to Input Version Manually,Allow to Input Document No Manually,Enable Edit Online,Training Completion Percentage Check for Doc Publish Reqd,Minimum Training Completion Percentage,Created On,Created By,Updated On,Updated By,Update Reason";
    this.message.whereClause_Report = "";
    this.message.report_And_Popup_Name = "Documents Settings Audit Trail";
    this.staticAuditTrailComponent.triggerTrail(0);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.tableOrView_Name = "DMS_SETTINGS_VW";
    this.excelPdf.columnList_DB = "DOCUMENT_NO_FORMAT,DOCUMENT_NO_REGENERATION,DOCUMENT_NO_NO_OF_DIGITS,DOCUMENT_NO_FORMAT_FOR_ASSOCIATED_DOCS,DOCUMENT_NO_REGENERATION_FOR_ASSOCIATED_DOCS,DOCUMENT_NO_NO_OF_DIGITS_FOR_ASSOCIATED_DOCS,DOCUMENT_NO_FORMAT_FOR_AMENDMENT_DOCS,DOCUMENT_NO_REGENERATION_FOR_AMENDMENT_DOCS,DOCUMENT_NO_NO_OF_DIGITS_FOR_AMENDMENT_DOCS,ALLOWED_FILE_EXTNS,PDF_CONVERTABLE_FILE_EXTNS,VIEWABLE_FILE_EXTNS,FOOTER_MESSAGE_FORMAT,WATERMARK_MESSAGE_FORMAT,DOWNLOADED_DOCUMENT_NAME_FORMAT,STATUSES_ALLOWED_AT_TRAININGS,REPORTS_TIMEZONE,ALLOW_TO_INPUT_VERSION_MANUALLY,ALLOW_TO_INPUT_DOCUMENT_NO_MANUALLY,ONLINE_EDITOR,TRAINING_COMPLETION_PERCENTAGE_CHECK_FOR_DOCUMENT_PUBLISH_REQD,TRAINING_COMPLETION_PERCENTAGE_FOR_DOCUMENT_PUBLISH,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON";
    this.excelPdf.columnList_Report = "Parent Document No. Format,Parent Document No. Regeneration,Document Number No. of Digits,Document No. Format for Associated Documents,Document No. Regeneration for Associated Documents,Document Number No. of Digits for Associated Documents,Document No. Format for Amendment Documents,Document No. Regeneration for Amendment Docs,Document Number No. of Digits for Amendment Documents,Allowed File Extensions,PDF Convertible File Extensions,Viewable File Extensions,Footer Message Format,Watermark Message Format,Downloaded Document Name Format,Statuses Allowed at Trainings,Reports Timezone,Allow to Input Version Manually,Allow to Input Document No Manually,Enable Edit Online,Training Completion Percentage Check for Doc Publish Reqd,Minimum Training Completion Percentage,Created On,Created By,Updated On,Updated By,Update Reason";
    this.excelPdf.whereClause_Report = '';
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = 'Documents Settings Report';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }

  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  onPercentageChange() {
    this.dmsSettingsObj.trainingCompletionPercentageForDocumentPublish = null;
  }

  onPercentageInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = Number(input.value);

    if (Number.isNaN(value)) {
      input.value = '';
      return;
    }

    if (value < 1) {
      input.value = '1';
    } else if (value > 100) {
      input.value = '100';
      this.showSnackBar('Minimum 1; Maximum 100.', 'E')
    }

    this.dmsSettingsObj.trainingCompletionPercentageCheckForDocumentPublishReqd = Number(input.value);
  }
}
